<template>
    <form-row title="Showings" :label_align_top="true">
        <div class="flex flex-col flex-1">
            <listing-showing-detail
                v-for="(showing, index) in showings"
                :key="showing.id"
                :index="index"
                :count="showings.length"
                :showing="showing"
                :read_only="read_only"
                @delete="deleteShowing"
            />

            <div class="flex flex-1 justify-end">
                <button v-if="! read_only"
                    type="button"
                    class="flex items-center text-xs uppercase text-blue-500 hover:text-blue-600 leading-none focus:shadow-none tracking-wide font-semibold sm:ml-46 my-4"
                >
                    <span class="text-lg font-bold mr-2">+</span>

                    <span class="inline-block py-2 cursor-pointer select-none"
                        @click="addShowing"
                        v-html="$t('Add Showing')"
                    >
                    </span>
                </button>
            </div>
        </div>
    </form-row>
</template>

<script>
import ListingShowingDetail from './listing-showing-detail.vue';

export default {
    components: {
        ListingShowingDetail,
    },

    props: {
        listing_detail: { default: () => ({}) },
        read_only: { default: false },
        listing_detail: {},
    },

    data() {
        return {
            showings: this.listing_detail.showings || [],
        }
    },

    methods: {
        addShowing() {
            this.showings.push(this.getEmptyContact());
        },
        deleteShowing(key) {
            const index = this.showings
                .findIndex(contact => contact.id == key);

            if (index > -1) {
                this.showings.splice(index, 1);
            }
        },
        getEmptyContact() {
            return {
                id: this.getRandomKey(),
                name: null,
                agent: null,
                date: null,
                email: null,
                phone: null,
                notes: null,
            };
        },
        getRandomKey() {
            return Math.floor(Math.random() * (99999999 - 1) + 1);
        },
    },
}
</script>
